import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const config: LayoutConfigTypes = {
  themeName: "StillTheme",
  themeVersion: "8.0.28",
  demo: "demo2",
  main: {
    type: "default",
    primaryColor: "#3161dc", //#009EF7
    logo: {
      dark: "media/logos/logo-StillOnline-couleur.svg",
      light: "media/logos/logo_sm.png",
    },
  },
  loader: {
    logo: "media/logos/logo_sm.png",
    display: true,
    type: "spinner-message",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "svg",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: false,
    width: "fluid",
    fixed: {
      desktop: false,
      tabletAndMobile: false,
    },
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "svg",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fluid",
  },
  footer: {
    width: "fixed",
  },
};

export default config;
